import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { ApiClient } from "@/shared/services/api-client";
import { GetAccountGroupsShareRequestModel, GetAccountGroupsShareResponseModel } from "@/features/accounts/account-group/services/get-account-groups-share-model";

export class GetAccountGroupsShareApi {
  /**
   * 口座グループ共有メンバー取得
   */
  public getAccountGroupsShare = async (
    param: GetAccountGroupsShareRequestModel
  ): Promise<GetAccountGroupsShareResponseModel> => {
    const path = `/api/accountgroups/share`;
    const res = await ApiClient.instance.get<GetAccountGroupsShareResponseModel>({
      path: path,
      params: param as NonNullable<unknown>,
    });

    if (res.ok === false) {
      throw MoneyLinkException.fromServer({ response: res });
    }

    return res.body;
  };
}
